import React from 'react';

const Xlsx = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="32"
      viewBox="0 0 31 32"
    >
      <title>xlsx</title>
      <path
        fill="#949494"
        d="M22.858 0l7.619 7.619v24.381h-24.381v-5.181l0.762 0.114v4.305h22.857v-22.857h-7.619v-7.619h-15.238v8.876l-0.762 0.114v-9.752h16.762zM27.429 25.905v1.524h-5.333v-1.524h5.333zM20.571 25.905v1.524h-5.333v-1.524h5.333zM27.429 22.857v1.524h-5.333v-1.524h5.333zM20.571 22.857v1.524h-5.333v-1.524h5.333zM27.429 19.81v1.524h-5.333v-1.524h5.333zM20.571 19.81v1.524h-5.333v-1.524h5.333zM27.429 16.762v1.524h-5.333v-1.524h5.333zM20.571 16.762v1.524h-5.333v-1.524h5.333zM27.429 13.714v1.524h-5.333v-1.524h5.333zM20.571 13.714v1.524h-5.333v-1.524h5.333zM27.429 10.667v1.524h-5.333v-1.524h5.333zM20.571 10.667v1.524h-5.333v-1.524h5.333zM22.857 1.143v6.476h6.476l-6.476-6.476z"
      ></path>
      <path
        fill="#217346"
        d="M15.238 8.381v19.81l-15.238-2.286v-15.238l15.238-2.286zM6.019 13.714h-2.704l2.876 4.571-3.144 4.571h2.649l1.706-2.952c0.119-0.285 0.195-0.497 0.227-0.638v0h0.027c0.069 0.298 0.135 0.502 0.2 0.612v0l1.699 2.977h2.635l-3.041-4.61 2.958-4.533h-2.477l-1.569 2.716c-0.151 0.353-0.255 0.618-0.31 0.797v0h-0.027c-0.087-0.298-0.186-0.555-0.296-0.771v0l-1.41-2.742z"
      ></path>
    </svg>
  );
};

export default Xlsx;
